<app-card>
  <ng-container cardBody>
    <div class="d-flex flex-wrap flex-sm-nowrap">
      <div class="me-7 mb-4 mb-lg-0">
        <div class="symbol symbol-48px symbol-lg-100px symbol-fixed position-relative">
          <app-skeleton-text type="image" [isLoading]="isLoading">
            <div class="rounded profile-image d-flex align-items-center justify-content-center">
              <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PROFILE_DEFAULT_BUSINESS" class="svg-icon svg-icon-24"></span>
            </div>
          </app-skeleton-text>
        </div>
      </div>

      <!-- begin:: user info -->
      <div class="flex-grow-1">
        <div class="d-flex align-items-start justify-content-between flex-wrap mb-2">
          <app-skeleton-text [isLoading]="isLoading" type="text">
            <div class="d-flex align-items-center mb-2">
              <h2 class="text-gray-900 text-hover-primary fs-2 fw-bold me-1 mb-0">{{ utilities.toCapitalize(name) }}</h2>
              <ng-container *ngIf="badge">
                <img [src]="badge" alt="badge" class="mx-2" />
              </ng-container>
            </div>
          </app-skeleton-text>

          <app-skeleton-text [isLoading]="isLoading" type="text">
            <span *ngIf="status" class="badge badge__status badge__status--{{ status.value }}">{{ status.string }}</span>
          </app-skeleton-text>
        </div>

        <app-skeleton-text [isLoading]="isLoading" [count]="3" type="icon-and-text">
          <div class="d-flex flex-wrap text-gray-700">
            <div class="d-flex align-items-center me-6" *ngFor="let list of labelList; let i = index" [attr.data-index]="i">
              <ng-container *ngIf="i !== 2; else locationAreas">
                <span class="svg-icon me-3" inlineSVG="{{ list.icon }}"></span>
                <span>{{ list.value }}</span>
              </ng-container>
              <ng-template #locationAreas>
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <span class="svg-icon me-3" inlineSVG="{{ list.icon }}"></span>
                    <span>{{ list.value }}</span>
                  </div>
                  <button
                    *ngIf="role === enumRole.ADMIN_GUDANG || role === enumRole.REGIONAL_DIRECTOR || role === enumRole.ADMIN || role === enumRole.FINANCE"
                    type="button"
                    class="btn btn-link text-info fw-bold p-0 pt-2 d-flex justify-content-start"
                    (click)="handleDetail()"
                  >
                    <span class="space-show"></span>
                    <span class="">Lihat Detail</span>
                  </button>
                </div>
              </ng-template>
            </div>
          </div>
        </app-skeleton-text>
      </div>
    </div>

    <div class="mt-6 mb-n6" *ngIf="noteViewInfo">
      <app-note-view [color]="'info'" [text]="noteViewInfo" [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION" />
    </div>
  </ng-container>
</app-card>

<app-modal #modalDetail [modalConfig]="modalConfig">
  <div *ngFor="let detail of details.value">
    <label class="mb-3">Area {{ detail }}</label>
  </div>
</app-modal>

<app-modal #modalWarehouse [modalConfig]="modalWarehouseConfig">
  <div *ngFor="let detail of details.value">
    <label class="mb-3">Gudang {{ detail }}</label>
  </div>
</app-modal>
